// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video-action[data-v-3f017408]{position:relative}.video-action .common[data-v-3f017408]{align-items:center;background:rgba(0,0,0,.05);border-radius:25px;cursor:pointer;display:flex;height:50px;justify-content:center;margin-top:9px;width:50px}.video-action .number[data-v-3f017408]{color:rgba(0,0,0,.88);font-size:14px;font-style:normal;font-weight:500;letter-spacing:-.15px;line-height:normal;margin-top:8px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
